import {_request, _requestForm} from "./api";

export const add = (date, competitions_guid) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _request({
            target: `competition-clubs/${competitions_guid}`, method: 'POST', params: params
        }).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (competitions_club_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `competition-clubs/${competitions_club_guid}`, method: 'DELETE'
        }).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const list = (competitions_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `competition-clubs/${competitions_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listUnused = (competitions_guid) => {
    console.log('xxxxxxxxxx',competitions_guid)
    return new Promise((resolve, reject) => {
        return _request({
            target: `competition-clubs/unused/${competitions_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};
